import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
  max-width: 800px;
  padding-top: 24px;

  & > :first-child {
    margin-bottom: 0 !important;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors.green1};
    border: 1px solid ${({ theme }) => theme.colors.green6};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0px 6px;
  justify-content: center;
  align-items: center;
  font-size: 30px;
`;

export const LabelWrapper = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CountWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black7};
`;
